export default __webpack_public_path__ + "static/media/favicon.co.0c9562ca.png";